import { useCallback, useEffect, useRef, useState } from 'react';

import { useFormik } from 'formik';
import { useSelector } from 'react-redux';

import LoadingComponent from 'components/LoadingComponent';
import { ENUM_TYPE_REPORT_STATUS, ENUM_TYPE_VIDEO } from 'constants/enum';
import useChildren from 'hooks/useChildren';
import { useResize } from 'hooks/useResize';
import ChatHistory from 'pages/Users/Detail/_components/ChatHistory/ChatHistory';
import RecentAnswerResultsAndVideoResults from 'pages/Users/Detail/_components/RecentAnswerResultsAndVideoResults/RecentAnswerResultsAndVideoResults';
import RecentEvaluationAnalysisResults from 'pages/Users/Detail/_components/RecentEvaluationAnalysisResults/RecentEvaluationAnalysisResults';
import RecentExerciseVideoSelection from 'pages/Users/Detail/_components/RecentExerciseVideoSelection/RecentExerciseVideoSelection';
import { calculateWidth, handleError } from 'utils/helper';

const INITIAL_DATA = {
  comment: '',
  scores: [],
  categories: [],
  list_dates: {
    reports: [],
    analysis: [],
  },
  status: ENUM_TYPE_REPORT_STATUS.FINISH,
};

const Home = () => {
  const { me } = useSelector((state) => state.auth);
  const { childrenDetail } = useSelector((state) => state.children);

  const { getDatesHasEvaluation, getEvaluationDetail } = useChildren();
  const { width } = useResize();

  const [isLoading, setIsLoading] = useState(true);
  const [datesHasEvaluation, setDatesHasEvaluation] = useState([]);
  const [datesHasVideo, setDatesHasVideo] = useState([]);
  const [datesReportRegistration, setDatesReportRegistration] = useState([]);
  const [selectedVideoASE, setSelectedVideoASE] = useState([]);
  const [selectedVideoDAY, setSelectedVideoDAY] = useState([]);

  const isCallingApi = useRef(false);

  const form = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: INITIAL_DATA,
  });

  // GET DETAIL EVALUATION
  const _getDetailEvaluation = async (id) => {
    if (id) {
      try {
        const response = await getEvaluationDetail(id);

        setDatesHasVideo(response.list_dates.reports);
        setDatesReportRegistration(response.list_dates.analysis);

        const categoriesASE = response.categories
          .filter((item) => item.videocategory_type === ENUM_TYPE_VIDEO.ASE)
          .map((item) => item.videocategory_id);

        const categoriesDAY = response.categories
          .filter((item) => item.videocategory_type === ENUM_TYPE_VIDEO.DAY)
          .map((item) => item.videocategory_id);

        setSelectedVideoASE(categoriesASE);
        setSelectedVideoDAY(categoriesDAY);

        form.setValues({
          comment: response.comment,
          scores: response.scores,
          categories: [],
          list_dates: {
            reports: response.list_dates.reports,
            analysis: response.list_dates.analysis,
          },
          status: response.status,
        });
      } catch (error) {
        handleError(error);
      }
    }
  };

  // GET DATES HAS EVALUATION
  const _getReportByDate = useCallback(async () => {
    if (me && childrenDetail?.id && !isCallingApi.current) {
      try {
        isCallingApi.current = true;

        const response = await getDatesHasEvaluation({ page: 1, page_size: 1 });
        if (response) {
          setDatesHasEvaluation(response);
          if (response.length > 0) {
            _getDetailEvaluation(response[0].id);
          }
        }
      } catch (error) {
        handleError(error);
      } finally {
        setTimeout(() => {
          isCallingApi.current = false;
          setIsLoading(false);
        }, 500);
      }
    }
  }, [me, childrenDetail?.id]);

  useEffect(() => {
    _getReportByDate();
  }, [_getReportByDate]);

  if (isLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingComponent />
      </div>
    );
  }

  return (
    <div className="flex space-x-4 h-full">
      {datesHasEvaluation.length <= 0 ? (
        <div style={calculateWidth(1344, 1920, width)} className="bg-white">
          <div className="w-full h-full flex justify-center items-center">データがありません</div>
        </div>
      ) : (
        <>
          <div style={calculateWidth(396, 1920, width)}>
            <RecentAnswerResultsAndVideoResults
              isRecently={true}
              datesHasVideo={datesHasVideo}
              datesReportRegistration={datesReportRegistration}
            />{' '}
          </div>
          <div style={calculateWidth(520, 1920, width)}>
            <RecentEvaluationAnalysisResults isRecently={true} form={form} />
          </div>
          <div style={calculateWidth(396, 1920, width)}>
            <RecentExerciseVideoSelection
              isRecently={true}
              selectedVideoASE={selectedVideoASE}
              selectedVideoDAY={selectedVideoDAY}
              setTypeVideo={() => {}}
              handleRemoveVideo={() => {}}
              setShowPopupAddExerciseVideo={() => {}}
            />
          </div>
        </>
      )}

      <div className="!w-full !max-w-full" style={calculateWidth(400, 1920, width)}>
        {childrenDetail?.id && <ChatHistory child_id={childrenDetail?.id} />}
      </div>
    </div>
  );
};

export default Home;
